<template>
  <el-pagination
    class="page-box"
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    background
    :current-page.sync="pager.currentPage"
    :page-sizes="[10, 20, 30, 40,100,500]"
    :page-size="pager.pageSize"
    layout="total, sizes, prev, pager, next, jumper"
    :total="pager.total"
  >
  </el-pagination>
</template>
<script>
export default {
  name: "Pagination",
  props: {
    pager: {
      type: Object,
      default: () => ({
        pageSize: 10,
        currentPage: 1,
        total: 1,
      }),
    },
  },
  methods: {
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.$emit("pager", this.pager);
    },
    handleCurrentChange(val) {
      this.pager.currentPage = val;
      this.$emit("pager", this.pager);
    },
  },
};
</script>

<style>
.page-box {
  margin: 10px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/pagination.vue